<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import Vue        from "vue";
import VueRouter  from "vue-router";
import ApiService from "@/services/ApiService";

const {
  isNavigationFailure,
  NavigationFailureType
} = VueRouter;

export default {
  name: "App",

  created() {
    Vue.$globalEvent.$on("httpError", (item) => {
      this.$toast.error(item && item.body && item.body.message || 'Erro não identificado');
    });
    Vue.$globalEvent.$on('httpRequestEnd', async (resp) => {
      if ((resp.status !== 401 && resp.status !== 418) || (!sessionStorage.getItem('token'))) {
        return;
      }
      if (resp.status === 418) {
        if (window.location.pathname.indexOf('-2fa') < 0) {
          this.$router.push({ name: 'Login2FA' }).catch((failure) => {
            if (isNavigationFailure(failure, NavigationFailureType.cancelled)) {
              this.$toast.warning('Redirecionando para confirmação via aplicativo...');
              return Promise.resolve();
            }
            return Promise.reject(failure);
          });
        }
        return;
      }
      this.$toast.error('Sessão expirada!');
      return await new Promise((acc) => setTimeout(acc, 1000))
        .then(() => {
          new ApiService().logout(this.$router);
        });
    });
  },

  data: () => ({
    error: "",
    showError: false,
  }),
};
</script>